import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import config from 'apps/notifications/config';

import FlashMessage from './FlashMessage';

export default class FlashMessages extends PureComponent {
  static propTypes = {
    hideFlashMessage: PropTypes.func.isRequired,
    messages: PropTypes.array.isRequired,
  };

  handleMessage = (id) => {
    this.props.hideFlashMessage(id);
  };

  render() {
    const { messages } = this.props;
    return (
      <div className="ntf-flashMessages__wrapper">
        <CSSTransitionGroup
          component="div"
          transitionName="ntf-flashMessages"
          transitionEnterTimeout={config.transitionEnterTimeout}
          transitionLeaveTimeout={config.transitionLeaveTimeout}
        >
          {messages.map((message) => (
            <FlashMessage
              key={message.id}
              id={message.id}
              text={message.text}
              level={message.level}
              sticky={message.sticky}
              hideMessage={this.handleMessage}
            />
          ))}
        </CSSTransitionGroup>
      </div>
    );
  }
}
